module.exports = __webpack_public_path__ + "static/img/partner2.ac4edb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner2.png
// module id = J156
// module chunks = 1